import * as React from 'react'
import { cn } from '../../lib/cn'

/**
 * KeyValueRow — inspector / detail list row. Pencil UWomg.
 */
export interface KeyValueRowProps extends React.HTMLAttributes<HTMLDivElement> {
  label: React.ReactNode
  value: React.ReactNode
  action?: React.ReactNode
  orientation?: 'horizontal' | 'vertical'
}

export const KeyValueRow = React.forwardRef<HTMLDivElement, KeyValueRowProps>(
  ({ className, label, value, action, orientation = 'horizontal', ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'border-b border-ia-border last:border-b-0 py-3',
        orientation === 'horizontal' ? 'flex items-center gap-4' : 'flex flex-col gap-1',
        className,
      )}
      {...props}
    >
      <div
        className={cn(
          'text-caption text-ia-text-tertiary',
          orientation === 'horizontal' && 'w-[160px] shrink-0',
        )}
      >
        {label}
      </div>
      <div className="flex-1 text-body-sm text-ia-text break-words min-w-0">{value}</div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  ),
)
KeyValueRow.displayName = 'KeyValueRow'
